import { defineStore } from 'pinia';

export const ErrorHandleStore = defineStore('ErrorHandleStore', {
  state: () => ({
    exceptionMessage: '',
    isExistException: false,
    isMaintenance: false,
    isExistBadRequestException: false,
    isDgftRequest: false,
  }),
  actions: {
    setExceptionMessage(message: string) {
      if (this.isExistException) return;
      this.exceptionMessage = message;
    },
  },
});
